module.exports = __webpack_public_path__ + "media/images/products/products/h2-3bf2875b951d79428a7f6004644d59bd.jpg";